import { render, staticRenderFns } from "./DisplaySizeMeasure.vue?vue&type=template&id=0f5c4208&"
import script from "./DisplaySizeMeasure.vue?vue&type=script&lang=js&"
export * from "./DisplaySizeMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports